import { createContext, useContext, useEffect, useState } from 'react'
import { checkAuthorizationStatus, signIn as login, signOut as logout, Credentials } from 'services/auth'

type Noop = () => void

type Auth = {
    isAuthorized: boolean
    authChecked: boolean
    signIn: (credentials: Credentials, cb: Noop, errorCb: Noop) => void
    signOut: (cb: Noop) => void
}

const AuthContext = createContext({} as Auth)

export function AuthProvider({ children }: { children: JSX.Element }) {
    const auth = useAuthProvider()
    return <AuthContext.Provider value={auth}>{children}</AuthContext.Provider>
}

export function useAuth() {
    return useContext(AuthContext)
}

function useAuthProvider(): Auth {
    const [isAuthorized, setIsAuthorized] = useState(false)
    const [authChecked, setAuthChecked] = useState(false)

    useEffect(() => {
        checkAuthorizationStatus().then(result => {
            setAuthChecked(true)
            setIsAuthorized(result)
        })
    }, [])

    const signIn = (credentials: Credentials, cb: Noop, errorCb: Noop) => {
        return login(
            credentials,
            () => {
                setAuthChecked(true)
                setIsAuthorized(true)
                cb()
            },
            errorCb
        )
    }

    const signOut = (cb: Noop) => {
        return logout(() => {
            setAuthChecked(false)
            setIsAuthorized(false)
            cb()
        })
    }

    return {
        isAuthorized,
        authChecked,
        signIn,
        signOut,
    }
}
